module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-2560-b8d46644fc121e7f5e85747c168352bd.jpg";